"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.PC_CONTENT_PAGE_QUERY_V2 = exports.PC_CALCULATION_QUERY_V2 = exports.ExtraLinks = exports.CalculationForm = exports.CALCULATION_FORM_QUERY_INLINE = exports.CALCULATION_FORM_QUERY = void 0;

var _calculationFormResolver = _interopRequireDefault(require("./components/calculation-form-resolver"));

exports.CalculationForm = _calculationFormResolver["default"];

var _query = require("./components/query");

exports.CALCULATION_FORM_QUERY_INLINE = _query.CALCULATION_FORM_QUERY_INLINE;
exports.CALCULATION_FORM_QUERY = _query.CALCULATION_FORM_QUERY;
exports.PC_CONTENT_PAGE_QUERY_V2 = _query.PC_CONTENT_PAGE_QUERY_V2;
exports.PC_CALCULATION_QUERY_V2 = _query.PC_CALCULATION_QUERY_V2;

var _extraLinks = _interopRequireDefault(require("./components/extra-links"));

exports.ExtraLinks = _extraLinks["default"];